import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { AuthService } from '../../core/services/auth.service';
import { UserPersistenceService } from '../../core/services/userPersistence.service';
import { Enums } from '../../shared/models/enums';
import ModalChangePasswordSchema from '../../shared/schemas/modals/modalChangePassword.json';
import { FormControlService } from '../../shared/services/form-control.service';
import { FormGroupGenerationService } from '../../shared/services/form-group-generation.service';
import { ToastService } from '../../shared/services/toast.service';
import { InputFieldComponent } from '../../shared/widgets/form/input-field/input-field.component';

@Component({
    selector: 'ifc-modal-change-password',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './modal-change-password.component.html',
    styleUrls: ['./modal-change-password.component.scss'],
    standalone: true,
    imports: [InputFieldComponent, MatButton]
})
export class ModalChangePasswordComponent implements OnInit {

    form: FormGroup;
    action: Subject<any> = new Subject();
    emailSent = false;
    schema = ModalChangePasswordSchema;
    confirmationStatus = Enums.confirmationStatus;
    userPasswordReset = false;
    passwordExpired = false;

    constructor(
        public modalRef: MDBModalRef,
        public userPersistenceService: UserPersistenceService,
        private formControlService: FormControlService,
        private fb: FormBuilder,
        private formGroupGenerationService: FormGroupGenerationService,
        private authService: AuthService,
        private toastService: ToastService,

        private cdr: ChangeDetectorRef) { }

    ngOnInit() {
        this.form = this.fb.group(this.formGroupGenerationService.createFormGroup(this.schema));
        this.updateControlLabel();
    }

    private updateControlLabel() {
        this.schema.properties.confirmPassword.title = this.userPersistenceService.generalTranslation.ConfirmPwd;
        this.schema.properties.newPassword.title = this.userPersistenceService.generalTranslation.NewPwd;
        this.schema.properties.oldPassword.title = this.userPasswordReset ? this.userPersistenceService.generalTranslation.TemporaryPwd : this.userPersistenceService.generalTranslation.OldPwd;
    }

    onCancelClick() {
        this.modalRef.hide();
        this.action.next({ status: this.confirmationStatus.cancel });
    }

    onSaveClick() {
        if (this.form.valid && this.form.controls.newPassword.value != this.form.controls.confirmPassword.value) {
            const confirmPassword = this.form.controls.confirmPassword;
            confirmPassword.updateValueAndValidity();
        }
        else if (this.form.valid) {
            this.authService.changePassword(this.form.value)
                .subscribe(response => {
                    this.toastService.success(this.userPersistenceService.generalTranslation.PwdSaved);
                    this.modalRef.hide();
                
                    this.cdr.markForCheck();}, (err) => {
                    if (err.error.message === "101") {
                        this.toastService.error(this.userPersistenceService.generalTranslation.IncorrectOldPwd);
                    }
                    else if (err.error.message === "102") {
                        this.toastService.error(this.userPersistenceService.generalTranslation.ReusePwd);
                    }
                    else if (err.error.message === "103") {
                        this.toastService.error(this.userPersistenceService.generalTranslation.PasswordChangedRecently);
                    }
                    else {
                        this.toastService.error(this.userPersistenceService.generalTranslation.ErrorMsg);
                    }
                
                    this.cdr.markForCheck();})
        }
        else {
          this.formControlService.callFormControlError(this.form);
        }
    }
}
